<div class="containers">
  <mat-form-field appearance="outline"  class=" full-grow-no-shrink-no-basis ">
    <mat-label>Value</mat-label>
    <input  matInput >
  </mat-form-field>
  <mat-accordion multi>
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="'36px'" [expandedHeight]="'36px'">
        <div class="header-text">
          Advanced
        </div>
      </mat-expansion-panel-header>

      <div class="footer">
        <button class="light-background-button" mat-button> Previous
        </button>
        <button class="action-button" mat-button> Next
        </button>
      </div>


    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion multi>
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="'36px'" [expandedHeight]="'36px'">
        <div class="header-text">
          Advanced
        </div>
      </mat-expansion-panel-header>

      <div class="footer-with-grid">
        <div class="row">
          <mat-form-field appearance="outline" style="min-width: 300px;">
            <mat-label>Search within</mat-label>
            <mat-select>
              <mat-option>Worksheet</mat-option>
              <mat-option>Worksheet2</mat-option>
              <mat-option>Worksheet3</mat-option>
            </mat-select>

          </mat-form-field>

          <mat-checkbox >Mactch case</mat-checkbox>
          <mat-checkbox >Match value</mat-checkbox>

        </div>
        <button class="action-button m-t-20" mat-button> Find All
        </button>
      </div>


    </mat-expansion-panel>
  </mat-accordion>
  <div class="record-text">7 records found</div>
</div>
